// base & libs
import { createApp } from 'vue';
import { createWebHistory, createRouter } from 'vue-router';
import dayjs from 'dayjs';
import { t } from './composables/i18n';
import { isLoggedIn, getLoggedUser } from './composables/useLogin';
import { keeper, searchObjectList } from './composables/utils';
import VueTippy from 'vue-tippy';
import Notifications, { notify } from 'notiwind';
import VueClipboard from 'vue3-clipboard';
// base css
import './index.css';
import { config, routes } from './routes';
// app route components
import App from './App.vue';

const router = createRouter({
    history: createWebHistory(),
    routes,
});

const regularRoute = (route) => {
    return searchObjectList(routes, 'name', route.name) || false;
};

// Avoid frame embedding
if (window.parent && window.location !== window.parent.location) {
    console.log('Frame detected & avoided');
    window.parent.location.href = 'https://www.google.com';
}

router.beforeEach(async (to) => {
    if (!regularRoute(to)) {
        return { name: 'error404' };
    }
    await isLoggedIn(config);
    const loggedUser = getLoggedUser();
    const requiredRoles = to.meta.requiredRoles || [];

    let routeAllowed = false;
    let loggedIn = loggedUser.id != '0';

    if (
        typeof requiredRoles === 'object' &&
        //isAllowedByOverride(to.name, loggedUser.id) &&
        (requiredRoles.length === 0 || requiredRoles.includes(loggedUser.role))
    ) {
        routeAllowed = true;
    }

    // Do not set return on login/logout
    if (to.path !== '/login' && to.path !== '/404') {
        keeper('returnUrl', to.path);
    }

    // Continue, when everything is ok
    if (loggedIn) {
        // Fix login path, when user is logged in
        if (to.path === '/login') {
            return '/';
        }
        // Everything fine, go
        if (routeAllowed) {
            if (Object.keys(to.query).length > 0) {
                keeper(`filter_${to.name}`, {
                    query: to.query,
                    params: to.params,
                });
            }
            return true;
        }
        // Nothing passed, no permission notified
        notify(
            {
                group: 'warning',
                title: `${t('Sorry')}`,
                text: `${t('NoPermission', { path: to.path })}`,
            },
            5000,
        );
        // Going nowhere
        return false;
    }

    // Log not logged user and reroute to login
    if (to.path !== '/login' && !routeAllowed && !loggedIn) {
        return { name: 'login' };
    }
});

const app = createApp(App);

app.provide('config', config);

app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.t = t;
app.config.globalProperties.keeper = keeper;
app.config.globalProperties.config = config;

app.use(
    VueTippy,
    // optional
    {
        directive: 'tippy', // => v-tippy
        component: 'tippy', // => <tippy/>
        componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
        defaultProps: {
            placement: 'top',
            allowHTML: true,
        },
        trigger: 'mouseenter',
        popperOptions: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['bottom', 'auto-end'],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true,
                        tether: false,
                    },
                },
            ],
        },
        hideOnClick: true, // => Global default options * see all props
        hideOnScroll: true,
    },
);
app.use(router);
app.use(Notifications);
app.use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true,
});

app.mount('#app');
